import { __awaiter, __generator } from "tslib";
import createBinding from '../api/create-binding';
import { isMobileDevice } from '../lib/device';
import { fixDomainSfx, getDomainSfx, langByDomainSfx, verifyLang } from '../utils';
import paymentForm from './payment-form';
function getCreateBindingParams(options) {
    var params = {
        mode: 'default',
        modeSuccess: 'default',
        lang: langByDomainSfx(getDomainSfx()),
        isMobile: isMobileDevice()
    };
    if (options.lang) {
        params.lang = verifyLang(options.lang);
    }
    if (options.mode) {
        params.mode = options.mode;
    }
    if (options.theme) {
        params.theme = options.theme;
    }
    if (options.modeSuccess) {
        params.modeSuccess = options.modeSuccess;
    }
    if (options.serviceToken) {
        params.serviceToken = options.serviceToken;
    }
    if (options.template) {
        params.template = options.template;
    }
    if (options.diehardTemplateTag) {
        params.diehardTemplateTag = options.diehardTemplateTag;
    }
    if (typeof options.remoteControl === 'boolean') {
        params.remoteControl = options.remoteControl;
    }
    if (typeof options.isMobile === 'boolean') {
        params.isMobile = options.isMobile;
    }
    if (options.currency) {
        params.currency = options.currency;
    }
    return params;
}
export default function bindCard(apiHost, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = options.queryParams;
                    url = options.url;
                    if (url) {
                        return [2, paymentForm(apiHost, { url: url, queryParams: queryParams })];
                    }
                    return [4, createBinding(apiHost, getCreateBindingParams(options))];
                case 1:
                    url = _a.sent();
                    url = fixDomainSfx(url, getDomainSfx());
                    return [2, paymentForm(apiHost, { url: url, queryParams: queryParams })];
            }
        });
    });
}
